import React, { memo, useEffect, useState } from 'react';
import { Panel, PanelHeader, PanelBody } from '../../../components/panel/panel.jsx';
import { useLocation, useHistory, useParams } from 'react-router';
import { Row, Col, Label, Form, FormGroup, Input, Media, Button } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { PriceFormat } from '../../../utils/format.js';
// import * as API from '../../../services/api';
import { UnControlled as CodeMirror } from 'react-codemirror2';
import { Notification } from '../../../utils/index.js';
import * as API from '../../../services/api';
import moment from 'moment';
import LoadingSpinner from '../../../components/common/LoadingSpinner.js';
require('codemirror/mode/xml/xml.js');
require('codemirror/mode/javascript/javascript.js');
const PaynamicsDetail = (props) => {
  const { id } = useParams();
  const location = useLocation();

  const { state } = props.location;

  const [paynamics, setPaynamics] = useState(state);

  const [loadingHistory, setLoadingHistory] = useState(false);
  const [history, setHistory] = useState([]);

  useEffect(() => {
    API.getPaynamicsTransaction(id)
      .then((res) => {
        setPaynamics(res.data.data);
        setHistory(res.data.data.history);
        setLoadingHistory(false);
      })
      .catch((err) => {
        setPaynamics(state);
        setHistory([]);
        setLoadingHistory(false);
      });
  }, [id]);

  return (
    <div>
      <h1 className="page-header">Paynamics Detail</h1>
      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Details</PanelHeader>
            <PanelBody>
              <FormGroup tag="fieldset">
                <Row>
                  <Col>
                    <FormGroup row>
                      <Col md="3">Date</Col>
                      <Col md="9">{paynamics.created_at}</Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col md="3">Customer</Col>
                      <Col md="9">{paynamics.user_full_name}</Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col md="3">Amount</Col>
                      <Col md="9">₱{paynamics.amount}</Col>
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup row>
                      <Col md="3">Request ID</Col>
                      <Col md="9">{paynamics.request_id}</Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col md="3">Type</Col>
                      <Col md="9">{paynamics.type_name}</Col>
                    </FormGroup>
                    <FormGroup row>
                      <Col md="3">Status</Col>
                      <Col md="9">{paynamics.status_name}</Col>
                    </FormGroup>
                  </Col>
                </Row>
              </FormGroup>
              <Row>
                <Col className="d-flex justify-content-end">
                  {paynamics.status_name != 'Success' && (
                    <ButtonForceCheck status={paynamics.status_name} />
                  )}
                  <ButtonQueryRequest query={paynamics.query} />
                  <ButtonLatestResponse response={paynamics.response} />
                  <ButtonRequestData requestData={paynamics.request_data} />
                </Col>
              </Row>
            </PanelBody>
          </Panel>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Response History</PanelHeader>
            <PanelBody>
              <div className="table-responsive">
                <table className="table table-striped mb-0 align-middle">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Action Item</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loadingHistory ? (
                      <tr>
                        <td colSpan={4} style={{ textAlign: 'center' }}>
                          <LoadingSpinner />
                        </td>
                      </tr>
                    ) : history.length ? (
                      history.map((history) => (
                        <tr key={history.id}>
                          <td>{moment(history.created_at).format('LLL')}</td>

                          <td nowrap="true">
                            <div>
                              <RowActionItemQueryRequest query={history.query} />
                              <RowActionItemResponse response={history.response} />
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={4} style={{ textAlign: 'center' }}>
                          No history(s) recorded
                        </td>
                      </tr>
                    )}

                    {/* <tr>
                      <td>August 22, 2022 04:04 AM</td>
                      <td>
                        <RowActionItemQueryRequest />
                        <RowActionItemResponse />
                      </td>
                    </tr>
                    <tr>
                      <td>August 22, 2022 04:04 AM</td>
                      <td>
                        <RowActionItemQueryRequest />
                        <RowActionItemResponse />
                      </td>
                    </tr> */}
                  </tbody>
                </table>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};

export default memo(PaynamicsDetail);

const ButtonRequestData = ({ requestData }) => {
  const [modalReject, setModalReject] = useState(false);

  const toggleModalReject = async () => {
    await setModalReject(!modalReject);
  };

  const codeMirrorOptions = {
    mode: 'application/xml',
    theme: 'material',
    lineNumbers: true,
    indentWithTabs: true,
    tabSize: 2,
    autoScroll: false
  };

  return (
    <>
      <button className="btn btn-primary mr-2" type="button" onClick={toggleModalReject}>
        Request Data
      </button>
      <Modal isOpen={modalReject} toggle={toggleModalReject} size="lg" centered={true}>
        <ModalHeader toggle={toggleModalReject}>Request Data Message</ModalHeader>
        <ModalBody>
          <CodeMirror options={codeMirrorOptions} value={requestData} />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={toggleModalReject}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const ButtonLatestResponse = ({ response = '{}' }) => {
  const [modalReject, setModalReject] = useState(false);

  const toggleModalReject = async () => {
    await setModalReject(!modalReject);
  };

  // const codeMirrorOptions = {
  //   mode: 'application/xml',
  //   theme: 'material',
  //   lineNumbers: true,
  //   indentWithTabs: true,
  //   tabSize: 2,
  //   autoScroll: false,
  //   alignCDATA: true
  // };

  // const json = response;
  const codeMirrorOptions = {
    mode: 'application/json',
    theme: 'material',
    lineNumbers: true,
    indentWithTabs: true,
    tabSize: 2,
    autoScroll: false
  };

  const json = JSON.parse(response);

  return (
    <>
      <button className="btn btn-primary mr-2" type="button" onClick={toggleModalReject}>
        Latest Response
      </button>
      <Modal isOpen={modalReject} toggle={toggleModalReject} size="lg" centered={true}>
        <ModalHeader toggle={toggleModalReject}>Latest Response Message</ModalHeader>
        <ModalBody>
          <CodeMirror options={codeMirrorOptions} value={JSON.stringify(json, null, 2)} />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={toggleModalReject}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const ButtonQueryRequest = ({ query = '{}' }) => {
  const [modalReject, setModalReject] = useState(false);

  const toggleModalReject = async () => {
    await setModalReject(!modalReject);
  };

  const codeMirrorOptions = {
    mode: 'application/json',
    theme: 'material',
    lineNumbers: true,
    indentWithTabs: true,
    tabSize: 2,
    autoScroll: false
  };

  const json = JSON.parse(query);
  return (
    <>
      <button className="btn btn-primary mr-2" type="button" onClick={toggleModalReject}>
        Query Request
      </button>
      <Modal isOpen={modalReject} toggle={toggleModalReject} size="lg" centered={true}>
        <ModalHeader toggle={toggleModalReject}>Query Request Message</ModalHeader>
        <ModalBody>
          <CodeMirror options={codeMirrorOptions} value={JSON.stringify(json, null, 2)} />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={toggleModalReject}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const ButtonForceCheck = ({ status = 'Pending' }) => {
  const { id } = useParams();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const onForceCheck = () => {
    setLoading(true);

    const onCheck =
      status === 'Pending' ? API.paynamicsCheckStatus(id) : API.paynamicsForceCheck(id);

    onCheck
      .then((res) => {
        setLoading(false);
        Notification.success('Paynamics Force Check', 'Transactions successfully updated');
        history.go(0);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        // Notification.error('Paynamics Force Check', err);
      });
  };

  return (
    <button
      type="button"
      onClick={onForceCheck}
      className={`btn ${loading ? 'btn-gray' : 'btn-warning'} mr-2`}
      disabled={loading}
    >
      {loading ? (
        <span>
          Checking Status <i className="fas fa-spinner fa-spin"></i>
        </span>
      ) : (
        `${status === 'Pending' ? '' : 'Force '}Check Status`
      )}
    </button>
  );
};

const RowActionItemQueryRequest = ({ query }) => {
  const [modalReject, setModalReject] = useState(false);

  const toggleModalReject = async () => {
    await setModalReject(!modalReject);
  };

  const codeMirrorOptions = {
    mode: 'application/json',
    theme: 'material',
    lineNumbers: true,
    indentWithTabs: true,
    tabSize: 2,
    autoScroll: false
  };

  const json = JSON.parse(query);

  return (
    <>
      <button className="btn btn-sm btn-primary mr-2" type="button" onClick={toggleModalReject}>
        Query Request
      </button>
      <Modal isOpen={modalReject} toggle={toggleModalReject} size="lg" centered={true}>
        <ModalHeader toggle={toggleModalReject}>Query Request Message</ModalHeader>
        <ModalBody>
          <CodeMirror options={codeMirrorOptions} value={JSON.stringify(json, null, 2)} />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={toggleModalReject}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

const RowActionItemResponse = ({ response }) => {
  const [modalReject, setModalReject] = useState(false);

  const toggleModalReject = async () => {
    await setModalReject(!modalReject);
  };

  const codeMirrorOptions = {
    mode: 'application/json',
    theme: 'material',
    lineNumbers: true,
    indentWithTabs: true,
    tabSize: 2,
    autoScroll: false
  };

  const json = JSON.parse(response);

  return (
    <>
      <button className="btn btn-sm btn-primary mr-2" type="button" onClick={toggleModalReject}>
        Response
      </button>
      <Modal isOpen={modalReject} toggle={toggleModalReject} size="lg" centered={true}>
        <ModalHeader toggle={toggleModalReject}>Response Message</ModalHeader>
        <ModalBody>
          <CodeMirror options={codeMirrorOptions} value={JSON.stringify(json, null, 2)} />
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-primary" onClick={toggleModalReject}>
            Close
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};
